import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import NoArticlesSvg from '../../../public/images/NoArticleSvg.svg';
import translations from '../../.vocab';

export const NoArticlesFound = () => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="medium" align="center">
      <Box
        marginTop="xlarge"
        style={{
          width: '100px',
          height: '102px',
          backgroundImage: `url(data:image/svg+xml;utf8,${encodeURIComponent(
            NoArticlesSvg,
          )})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
      <Box textAlign="center" margin="large">
        <Stack space="large">
          <Text weight="strong" size="large">
            {t('No articles found')}
          </Text>
        </Stack>
      </Box>
    </Stack>
  );
};
